export default {"src":"/_next/static/media/logoBlock6_3.5fded847.svg","height":81,"width":186,"blurWidth":0,"blurHeight":0};